import React, { useState, useEffect } from 'react';
import { getDomainCfg, store } from '../../core/state';
import * as api from '../../features/chatrequests';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CHAT_VIEW_NAME } from '../../core/constants';

interface CreditIndicatorProps {
  triggerFetch?: boolean;
  className?: string; // Add this line
}

export const CreditIndicator: React.FC<CreditIndicatorProps> = ({ 
  triggerFetch = false, 
  className = '' // Add this line
}) => {
  const [chatState, setChatState] = store.useState(CHAT_VIEW_NAME);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAndUpdateCredits = async () => {
    if (isLoading) return; // Verhindere mehrfache gleichzeitige Aufrufe
    
    setIsLoading(true);
    try {
      const creditData = await api.fetchUserCredits();
      const newChatState = {
        ...chatState,
        data: {
          ...chatState.data,
          credits: creditData
        }
      };
      setChatState(newChatState);
    } catch (error) {
      console.error('Error fetching credits:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Beim Mount prüfen, ob Credits vorhanden sind, wenn nicht, selbst holen
  useEffect(() => {
    const creditsAvailable = chatState?.data?.credits?.credits !== undefined;
    if (!creditsAvailable) {
      fetchAndUpdateCredits();
    }
  }, []); // Nur beim Mount ausführen

  // Wenn triggerFetch gesetzt ist, Credits neu laden
  useEffect(() => {
    if (triggerFetch) {
      fetchAndUpdateCredits();
    }
  }, [triggerFetch]);

  const handleClick = () => {
    window.open(getDomainCfg().chatSettings.creditPurchaseUrl, '_blank');
  };

  const magicStick = <FontAwesomeIcon 
      icon="wand-magic-sparkles" 
      onClick={fetchAndUpdateCredits} 
      style={{ cursor: 'pointer' }} 
    />;

  const creditsValue = chatState?.data?.credits?.credits;
  const creditsAvailable = creditsValue !== undefined;
  
  let creditsText = 'Keine Credits';
  if (creditsAvailable) {
    creditsText = `Credits: ${creditsValue}`;  
  } else if (isLoading) {
    creditsText = 'Lade Credits...';
  }

  return (
    <span className={`credit-indicator ${className}`} style={{ cursor: 'pointer' }}>
      {magicStick}
      <span 
        onClick={handleClick}
        style={{
          color: creditsAvailable && creditsValue <= 0 ? 'red' : 'inherit',
          textDecoration: creditsAvailable && creditsValue <= 0 ? 'underline' : 'none',
          fontWeight: creditsAvailable && creditsValue <= 0 ? 'bold' : 'normal'
        }}
      >
        {creditsText}
      </span>
      
    </span>
  );
};